export default __webpack_public_path__ + "static/media/floral.b5598ec3.png";